import GroupRow from "./GroupRow"
import $ from "jquery"
import TimeZonesSelector from "../../controls/TimeZonesSelector"

export default class TimeZoneGroupRow extends GroupRow {
    init(div, deleteLink, undoDeleteButton, acceptDeleteButton, undoEditButton, acceptEditButton, input, nameCell,
            inputCell, editGroupCell, waitingAnimationCell, group, validatorGroupStrategy, controller, selectorId) {
        super.init(div, deleteLink, undoDeleteButton, acceptDeleteButton, undoEditButton, acceptEditButton, input, nameCell,
                inputCell, editGroupCell, waitingAnimationCell, group, validatorGroupStrategy, controller);
        this.cityPlaceId = group.cityPlaceId;
        this.cityName = group.cityName;
        this.timeZoneId = group.timeZoneId;
        this.rawOffset = group.rawOffset;
        this.currentTime = group.currentTime;
        const self = this;
        this.controller = controller;
        this.citySelector = new TimeZonesSelector().init(
                $("#" + selectorId),
                {name: group.cityName, placeId: group.cityPlaceId, timeZoneId: group.timeZoneId, rawOffset: group.rawOffset},
                function() { self.cityChanged.apply(self, arguments) },
                null,
                false,
                "timeZoneGroupRowSearch",
                true
        );

        return this;
    }

    cityChanged(city) {
        this.cityName = city.name;
        this.cityPlaceId = city.placeId;
        this.timeZoneId = city.timeZoneId;
        this.rawOffset = city.rawOffset;
        this.currentTime = city.currentTime;
        this.controller.getGroupController().startNewGroupNameSaving(this.controller, this);
    }

    cleanup() {
        this.citySelector.resetToInit();
    }
}


// WEBPACK FOOTER //
// ./web/js/groupManagement/entities/TimeZoneGroupRow.js